import React from 'react';

const baseProps = {
  width: 20,
  height: 20,
  stroke: 'currentColor',
  fill: 'none',
  strokeWidth: 2,
  strokeLinecap: 'round',
  strokeLinejoin: 'round'
};

export const Calendar = (props) => (
  <svg {...baseProps} {...props} viewBox="0 0 24 24" aria-hidden="true">
    <rect x="3" y="5" width="18" height="16" rx="2" ry="2" />
    <line x1="3" y1="10" x2="21" y2="10" />
    <line x1="8" y1="3" x2="8" y2="7" />
    <line x1="16" y1="3" x2="16" y2="7" />
  </svg>
);

export const Zap = (props) => (
  <svg {...baseProps} {...props} viewBox="0 0 24 24" aria-hidden="true">
    <polyline points="13 2 3 14 12 14 11 22 21 10 12 10 13 2" />
  </svg>
);

export const TrendingUp = (props) => (
  <svg {...baseProps} {...props} viewBox="0 0 24 24" aria-hidden="true">
    <polyline points="23 6 13.5 15.5 8.5 10.5 1 18" />
    <polyline points="17 6 23 6 23 12" />
  </svg>
);

export const Info = (props) => (
  <svg {...baseProps} {...props} viewBox="0 0 24 24" aria-hidden="true">
    <circle cx="12" cy="12" r="10" />
    <line x1="12" y1="16" x2="12" y2="12" />
    <line x1="12" y1="8" x2="12.01" y2="8" />
  </svg>
);

export const ChevronLeft = (props) => (
  <svg {...baseProps} {...props} viewBox="0 0 24 24" aria-hidden="true">
    <polyline points="15 18 9 12 15 6" />
  </svg>
);

export const ChevronRight = (props) => (
  <svg {...baseProps} {...props} viewBox="0 0 24 24" aria-hidden="true">
    <polyline points="9 18 15 12 9 6" />
  </svg>
);

export const Star = (props) => (
  <svg {...baseProps} {...props} viewBox="0 0 24 24" aria-hidden="true">
    <polygon points="12 2 15 9 22 9 17 14 19 21 12 17 5 21 7 14 2 9 9 9 12 2" />
  </svg>
);

export const Globe = (props) => (
  <svg {...baseProps} {...props} viewBox="0 0 24 24" aria-hidden="true">
    <circle cx="12" cy="12" r="10" />
    <line x1="2" y1="12" x2="22" y2="12" />
    <path d="M12 2c2.5 3 2.5 15 0 20" />
    <path d="M12 2c-2.5 3-2.5 15 0 20" />
  </svg>
);

const icons = {
  Calendar,
  Zap,
  TrendingUp,
  Info,
  ChevronLeft,
  ChevronRight,
  Star,
  Globe
};

export default icons;
